module.exports = __webpack_public_path__ + "static/img/serveone-thumb.32f056c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/serveone-thumb.jpg
// module id = 6/kL
// module chunks = 0